import styled from 'styled-components'
import { tokens, Button } from '@arvoreeducacao/bonsai-ds'
import type { ModalProps } from 'components/lib/modals'
import Modal from 'components/lib/modals/Modal'

export const StyledModal = styled(Modal)<ModalProps>`
  padding: 12px;
  width: 90%;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    width: 500px;
  }
`

export const CustomButton = styled(Button)`
  width: 100%;
  margin: 32px 0 0 0;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    width: 190px;
    margin-left: auto;
  }
`

export const Title = styled.p`
  font-weight: bold;
  font-size: ${tokens.sizes.h[4].tablet};
  line-height: 30px;
  color: ${tokens.colors.black6};
  margin: 0 0 16px 0;
`

export const Content = styled.div`
  font-size: ${tokens.sizes.text}px;
  line-height: 28px;
  color: ${tokens.colors.black4};
  > ul {
    margin: 0;
    padding-left: 30px;
  }
  > a {
    color: ${tokens.colors.primary};
  }
`
